import { BRAND } from "@/lib/brand";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#3B2A22] text-[#FFFDF9] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-[#FFFDF9]/15">
          <div className="lg:col-span-5 space-y-4">
            <div className="font-serif text-3xl">
              The Best <em className="italic text-[#B88746]">Bronze</em>
            </div>
            <p className="text-[#FFFDF9]/75 text-sm leading-relaxed max-w-md">
              {BRAND.slogan}
            </p>
            <div className="flex items-center gap-3 pt-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-[#FFFDF9]/25 flex items-center justify-center hover:bg-[#B88746] hover:border-[#B88746] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full border border-[#FFFDF9]/25 flex items-center justify-center hover:bg-[#B88746] hover:border-[#B88746] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-4">
            <div className="section-label" style={{ color: "#D7B899" }}>
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={BRAND.phoneHref}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-[#FFFDF9]/85 hover:text-[#B88746] transition-colors"
                >
                  <Phone size={16} className="mt-0.5 flex-shrink-0" />
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.emailHref}
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-[#FFFDF9]/85 hover:text-[#B88746] transition-colors"
                >
                  <Mail size={16} className="mt-0.5 flex-shrink-0" />
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#FFFDF9]/85">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                {BRAND.address}
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4 space-y-4">
            <div className="section-label" style={{ color: "#D7B899" }}>
              Program
            </div>
            <ul className="space-y-2 text-sm text-[#FFFDF9]/85">
              <li className="flex justify-between border-b border-[#FFFDF9]/10 pb-2">
                <span>Luni – Vineri</span>
                <span>09:00 – 19:00</span>
              </li>
              <li className="flex justify-between border-b border-[#FFFDF9]/10 pb-2">
                <span>Sâmbătă</span>
                <span>10:00 – 16:00</span>
              </li>
              <li className="flex justify-between">
                <span>Duminică</span>
                <span>Închis</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#FFFDF9]/55">
          <p data-testid="footer-copyright">
            © 2026 The Best Bronze. Toate drepturile rezervate.
          </p>
          <p className="uppercase tracking-[0.2em]">Spray Tan Organic · Piatra Neamț</p>
        </div>
      </div>
    </footer>
  );
}
